import { range } from 'utilities/helperFunctions';

require('./RAVerticalSliderStep.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
// @ components
const RARiskInput = require('components/RAComponents/commons/RARiskInput/RARiskInput');
const RASingleSlider = require('components/RAComponents/commons/RASingleSlider/RASingleSlider');
const { InfoTooltip } = require('components/tooltip/tooltip');
// @ utilities
import { FormattedText, formatText } from 'core/i18n';

class RAVerticalSliderStep extends React.Component {
    getSliderLabels() {
        const options = range(0, 30, 5);
        const labels = options.map((option, i) => {
            return <div className="ra-vertical-slider__labels__number" key={i}>{`${option}%`}</div>;
        });

        return (
            <div className="ra-vertical-slider__labels hidden-xs">
                {labels}
                <div className="ra-vertical-slider__labels__max">
                    <div className="ra-vertical-slider__labels__description">
                        <FormattedText value="sliderLabels-maxLabel" />
                    </div>
                    <div className="ra-vertical-slider__labels__number">
                        <FormattedText value="sliderLabels-percentage" injectedStrings={[25]} />
                    </div>
                </div>
            </div>
        );
    }

    getSliderLooseLabels() {
        const options = range(5, 30, 5);
        const labels = options.map((option, i) => {
            const labelClassName = classNames('ra-vertical-slider__labels__number', {
                'ra-vertical-slider__labels__number--hidden': this.props.sliderValue !== option,
            });

            return <div className={labelClassName} key={i}>{`${option}%`}</div>;
        });

        return (
            <div className="ra-vertical-slider__labels hidden-lg hidden-md hidden-sm">
                <div className="ra-vertical-slider__labels__min">
                    <div className="ra-vertical-slider__labels__description">
                        <FormattedText value="sliderLabels-minLabel" />
                    </div>
                </div>
                {labels}
                <div className="ra-vertical-slider__labels__max">
                    <div className="ra-vertical-slider__labels__description">
                        <FormattedText value="sliderLabels-maxLabel" />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            amount,
            changeSliderValue,
            disabled,
            sliderValue,
            subtitle,
            title,
            updateVolatilityInputValue,
            recordEventTooltipClick,
            recordEventSliderClick,
            recordEventInputClick,
        } = this.props;
        const sliderLabels = this.getSliderLabels();
        const sliderLooseLabels = this.getSliderLooseLabels();

        return (
            <section className="ra-vertical-slider">
                <div className="ra-vertical-slider__header">
                    <span className="ra-vertical-slider__title">
                        {title}
                        <div className="tooltip-wrapper" onClick={recordEventTooltipClick}>
                            <InfoTooltip text={formatText('volatilityVerticalSlider-tooltip')} />
                        </div>
                    </span>
                    <span className="ra-vertical-slider__subtitle">{subtitle}</span>
                </div>
                <div className="ra-vertical-slider__disclaimer">
                    <p className="ra-vertical-slider__disclaimer-first-paragraph">
                        <FormattedText value="volatilityVerticalSlider-disclaimer1" />
                    </p>
                </div>
                <div className="ra-vertical-slider__container">
                    <div className="ra-vertical-slider__container__slider" onMouseDown={recordEventSliderClick}>
                        <RASingleSlider
                            disabled={disabled}
                            max={30}
                            maxLabel="25"
                            min={0}
                            minLabel="0"
                            onChange={changeSliderValue}
                            value={sliderValue}
                        />
                    </div>
                    {sliderLabels}
                    {sliderLooseLabels}
                </div>
                <div className="ra-vertical-slider__container__risk hidden-xs" onClick={recordEventInputClick}>
                    <RARiskInput
                        amount={amount}
                        updateVolatilityInputValue={updateVolatilityInputValue}
                        showBlurZero={true}
                        sliderValue={sliderValue}
                        disabled={disabled}
                    />
                </div>
                <div className="ra-vertical-slider__disclaimer">
                    <p>
                        <FormattedText value="volatilityVerticalSlider-disclaimer2" />
                    </p>
                </div>
            </section>
        );
    }
}

RAVerticalSliderStep.propTypes = {
    amount: PropTypes.number,
    changeSliderValue: PropTypes.func,
    disabled: PropTypes.bool,
    sliderValue: PropTypes.number,
    subtitle: PropTypes.string,
    title: PropTypes.string,
    updateVolatilityInputValue: PropTypes.func,
};

module.exports = RAVerticalSliderStep;
